import {
  pgTable,
  uuid,
  text,
  timestamp,
  integer,
  jsonb,
  uniqueIndex,
  index,
} from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// oauth_integrations — encrypted OAuth tokens for third-party integrations
// ---------------------------------------------------------------------------

export const oauthIntegrations = pgTable(
  "oauth_integrations",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    providerId: text("provider_id").notNull(),
    providerAccountId: text("provider_account_id").notNull(),
    encryptedAccessToken: text("encrypted_access_token").notNull(),
    encryptedRefreshToken: text("encrypted_refresh_token"),
    encryptedDek: text("encrypted_dek").notNull(),
    tokenType: text("token_type").default("bearer").notNull(),
    scope: text("scope").default("").notNull(),
    expiresAt: timestamp("expires_at", tz),
    refreshExpiresAt: timestamp("refresh_expires_at", tz),
    status: text("status").default("active").notNull(),
    lastRefreshedAt: timestamp("last_refreshed_at", tz),
    lastUsedAt: timestamp("last_used_at", tz),
    failureCount: integer("failure_count").default(0).notNull(),
    metadata: jsonb("metadata").default({}).notNull(),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", tz).defaultNow().notNull(),
  },
  (table) => [
    uniqueIndex("uq_oauth_tenant_provider_account").on(
      table.tenantId,
      table.providerId,
      table.providerAccountId,
    ),
    index("idx_oauth_tenant").on(table.tenantId),
    index("idx_oauth_status_expires").on(table.status, table.expiresAt),
  ],
);
